// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"selectionCard_checkbox__1K7t_","input":"selectionCard_input__-C7kU"};